<template>
  <div>
    <v-card
      v-if="
        checkaccessdata.is_viewer == false &&
        checkaccessdata.is_checker == false
      "
      class="mt-16"
      flat
    >
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </v-card>
    <v-card elevation="0" v-else>
      <v-row class="mt-1">
        <v-col cols="12" lg="12" xl="12" md="12" sm="12" xs="12">
          <v-data-table
            dense
            :headers="OrgHeader"
            :items="deptitems"
            :no-data-text="Nodata"
          >
            <template v-slot:[`item.sl_no`]="{ item }">
              <span class="caption">{{ deptitems.indexOf(item) + 1 }}</span>
            </template>
            <template v-slot:[`item.duration`]="{ item }">
              <!-- <span v-if="item.duration == '1'" class="caption">Daily</span> -->
              <span v-if="item.duration == '2'" class="caption">Weekly</span>
              <span v-if="item.duration == '3'" class="caption">Monthly</span>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <div class="green--text caption" v-if="item.status == '1'">
                Active
              </div>
              <div class="red--text caption" v-if="item.status == '0'">
                Inactive
              </div>
            </template>
            <template v-slot:top>
              <v-card
                :width="isMobile ? '310' : 'auto'"
                elevation="1"
                class="mb-5 ml-2 mr-2"
                rounded="xl"
              >
                <v-row>
                  <v-col cols="12" lg="10" xl="10" md="10" sm="12" xs="12">
                    <v-card-title class="ml-n2">
                      <span class="primary--text Heading 6"
                        >Set Budget Duration</span
                      >
                    </v-card-title>
                    <v-radio-group
                      v-model="radios"
                      mandatory
                      class="ml-3 mt-n3"
                      row
                    >
                      <v-radio label="Weekly" value="Weekly"></v-radio>
                      <v-radio label="Monthly" value="Monthly"></v-radio>
                    </v-radio-group>
                  </v-col>

                  <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
                    <v-btn
                      rounded
                      class="navbar white--text mt-7"
                      @click="AddBudgetopen()"
                    >
                      <v-icon>mdi-plus</v-icon>Add
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog persistent v-model="AddBudget" width="550">
      <v-toolbar dark dense class="header">
        <v-icon>mdi-currency-btc</v-icon>
        <span class="ml-3">Add Budget</span>
        <v-spacer></v-spacer>
        <v-btn class text dark @click="closebudget()">
          <v-icon color="white" class="mt-1" small>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-divider></v-divider>
        <v-form ref="form">
          <v-row class="mx-7 mt-8">
            <v-card
              readonly
              elevation="0"
              v-model="duration"
              class="mt-n5 mb-3"
            >
              <span class="primary--text">{{ placeholder }}</span></v-card
            >
          </v-row>
          <v-row class="mx-7">
            <v-text-field
              v-model="money"
              label="Add Budget to organization"
              dense
              outlined
              :hint="max_amount"
              persistent-hint
              :color="redcolor"
              class="mt-2 ml-n1"
              @keypress="isNumber(event)"
            ></v-text-field>
          </v-row>
          <span
            style="font-size: 15px"
            class="red--text mt-n6 ml-7"
            v-if="money != 0"
            >Your Previous Budget Will be Reset !!</span
          >
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary white--text" @click="createbudget()" rounded
            >Add Budget</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";
export default {
  data: () => ({
    checkaccessdata: {},
    money: "",
    search: "",
    radios: null,
    AddBudget: false,
    placeholder: "",
    duration1: "",
    assigndialog: false,
    OrgHeader: [
      { text: "SL NO", value: "sl_no" },
      {
        text: "DATE",
        value: "created_on",
      },
      {
        text: "DURATION",
        value: "duration",
      },
      {
        text: "BUDGET",
        value: "total_budget",
      },
      {
        text: "ALLOCATED BUDGET",
        value: "allocated_budget",
      },
      {
        text: "UNALLOCATED BUDGET",
        value: "unallocated_budget",
      },
      {
        text: "STATUS",
        value: "status",
      },
    ],
    deptitems: [],
    Nodata: "",
    duration: "",
    max_amount: "",
    redcolor: "",
    error: "",
  }),
  // mounted() {
  //   this.getorgbudgetdeatils();
  // },
  watch: {
    // money(val){
    //   // console.log("val",val)
    //  if (
    //         Number(val) != 0
    //       ) {
    //         this.max_amount = `Your Previous Budget Will Be Reset`;
    //         this.redcolor =  this.max_amount == "Your Previous Budget Will Be Reset" ? "red--text" : "grey--text";
    //         this.error = true;
    //       } else {
    //         this.max_amount = ``;
    //         this.redcolor = "";
    //         this.error = false;
    //       }
    // }
  },
  created() {
    this.checkaccess();
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "BUDGET",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      // console.log("checkaccessdata", this.checkaccessdata);
      if (this.checkaccessdata.is_viewer == true) {
        this.getorgbudgetdeatils();
      }
    },
    closebudget() {
      this.money = "";
      this.AddBudget = false;
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },
    async getorgbudgetdeatils() {
      var inputData = {
        method_name: "BUDGET",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETORG",
          corp_id: this.$store.getters.get_corpid,
        },
      };

      var responseData = await apiCall(inputData);
      // console.log("getorgeData", responseData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.deptitems = responseData.data.data;
          var self = this;
          self.deptitems.forEach(function (ele) {
            if (ele.status == 1) {
              self.radios = self.getdurationmon(ele);
            }
          });
        }
      } else if (responseData.data.status == "NOREC") {
        this.deptitems = [];
        this.Nodata = responseData.data.status_msg;
      }
    },
    getdurationmon(data) {
      if (data.duration == "2") {
        return "Weekly";
      } else if (data.duration == "3") {
        return "Monthly";
      }
    },
    AddBudgetopen() {
      //  console.log(this.radios);
      // if (this.radios == "Daily") {
      //   this.placeholder = "Duration Selected: Daily";
      //   this.duration1 = "1";
      // } else
      if (this.radios == "Weekly") {
        this.placeholder = "Duration Selected: Weekly";
        this.duration1 = "2";
      } else if (this.radios == "Monthly") {
        this.placeholder = "Duration Selected: Monthly";
        this.duration1 = "3";
      }

      this.AddBudget = true;
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async createbudget() {
      var inputData = {
        method_name: "BUDGET",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CREATEORG",
          corp_id: this.$store.getters.get_corpid,
          org_budget: this.money,
          duration: this.duration1,
        },
      };

      var responseData = await apiCall(inputData);
      // console.log("budgetdata", responseData);
      if (responseData.data.status == "00") {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "green",
        });
        this.getorgbudgetdeatils();
        this.assigndialog = false;
        this.AddBudget = false;
        this.$refs.form.reset();
        this.$refs.form.resetValidation();
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
        this.assigndialog = false;

        this.AddBudget = false;
        this.$refs.form.reset();
        this.$refs.form.resetValidation();
      }
    },
  },
};
</script>
<style>
.navbar {
  background: linear-gradient(to bottom, #2e4152 0%, #3c4d5d 50%, #202c37 100%);
}
</style>
